import { AnimatePresence, motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import useCloseWhenClickedOutside from "../../../../../../hooks/useCloseWhenClickedOutside";

export default function Tooltip({ 
    showTooltip, 
    setShowTooltip,
    tooltipButtonpRef 
}: {
    showTooltip: boolean;
    setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>;
    tooltipButtonpRef: React.RefObject<HTMLButtonElement | null>;
}) {
    const { t } = useTranslation();

    useCloseWhenClickedOutside({
		refs: [tooltipButtonpRef],
		setState: setShowTooltip,
	});

	return (
		<AnimatePresence>
			{showTooltip && (
				<motion.div
					className={`
                        origin-top absolute 
                        top-full left-0 z-10 
                        mt-1 p-4 xl:p-6 2xl:p-[1.6vw]
                        rounded-md shadow-md 
                        bg-yellow-50 dark:bg-gray-50/85
                        w-[140%] xs:w-[150%] 
                        overflow-hidden 
                        text-wrap text-[100%] md:text-[85.72%]
                    `}
					initial={{ opacity: 0, scale: 0 }}
					animate={{ opacity: 1, scale: 1 }}
					exit={{ opacity: 0, scale: 0 }}
					transition={{ duration: 0.2, ease: "easeOut" }}
                    role="tooltip"
                    id="forceSystemThemeTooltip"
				>
					<p>
						{t(`navBarItems.toolsMenu.forceSystemTheme.tooltip.on`)}
					</p>
					<p className="mt-2 2xl:mt-[0.5vw]">
						{t(`navBarItems.toolsMenu.forceSystemTheme.tooltip.off`)}
					</p>
				</motion.div>
			)}
		</AnimatePresence>
	);
}